import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {CookiesManager} from "../cookies";
import {RoleService, SessionService} from "../security";
import {Observable} from "rxjs/Observable";

@Injectable()
export class SessionGuard implements CanActivate, CanActivateChild {

    constructor(private _router: Router,
                private _sessionService: SessionService,
                private roleService: RoleService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkToken(state.url);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkToken(state.url);
    }

    private checkToken(url): boolean | Observable<boolean> {
        if (this.isTokenExist()) {
            if (this.roleService.arePermissionsLoaded()) {
                return true;
            } else {
                return this.roleService.fetchPermissions()
                    .map(() => true);
            }
        }

        this.saveDestinationURL(url);
        this._sessionService.setSessionCloseAsExpire();
        this._router.navigate(['login']);
        return false;
    }

    private isTokenExist(): boolean {
        return CookiesManager.isTokenExist();
    }

    private saveDestinationURL(url: string) {
        if (!url.includes('login') && url.length > 3) {
            CookiesManager.setDestinationURL(url);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/security/session.guard.ts